/**
 * Names of the OneGraph request headers this app sets.
 */

/**
 * Client tracking key. Set globally on every OneGraph request by the Apollo client (from the CTK
 * cookie); OneGraph may mint a new one and return it in `indeed-ctk-generated`.
 */
export const CTK_HEADER = 'indeed-ctk';

/**
 * The draft's root tracking key (its iaUid). Smart-apply subgraphs (screener questions, saved-answer
 * reads/writes, preview, submit) require it; the global Apollo client does not set it, so each
 * operation attaches it via Apollo `context.headers` with the draft's iaUid as the value.
 */
export const ROOT_TRACKING_KEY_HEADER = 'indeed-root-tracking-key';
